/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Shortcuts_Mock_Action_RuleInputs */

const tr_landing_shortcuts_mock_action_rule = /** @type {(inputs: Landing_Shortcuts_Mock_Action_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni kural oluştur`)
};

const en_landing_shortcuts_mock_action_rule = /** @type {(inputs: Landing_Shortcuts_Mock_Action_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create new rule`)
};

const de_landing_shortcuts_mock_action_rule = /** @type {(inputs: Landing_Shortcuts_Mock_Action_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Regel erstellen`)
};

const ru_landing_shortcuts_mock_action_rule = /** @type {(inputs: Landing_Shortcuts_Mock_Action_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать новое правило`)
};

/**
* | output |
* | --- |
* | "Create new rule" |
*
* @param {Landing_Shortcuts_Mock_Action_RuleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_shortcuts_mock_action_rule = /** @type {((inputs?: Landing_Shortcuts_Mock_Action_RuleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Shortcuts_Mock_Action_RuleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_shortcuts_mock_action_rule(inputs)
	if (locale === "de") return de_landing_shortcuts_mock_action_rule(inputs)
	if (locale === "ru") return ru_landing_shortcuts_mock_action_rule(inputs)
	return tr_landing_shortcuts_mock_action_rule(inputs)
});